import { useEffect } from 'react';
import { EventBus } from '@campus/core';

/**
 * Publie sur <html> la place réellement prise par les barres du jeu, mesurée :
 * - `--pl-hud-top` : bas des boutons du haut (`[data-hud-top]`), en px depuis le haut de la fenêtre, encoche comprise ;
 * - `--pl-hud-bottom` : haut de la barre du bas (`[data-hud-bottom]`), en px depuis le bas de la fenêtre ;
 * - `--pl-hud-tools` : largeur des boutons du haut à droite.
 * Les éléments flottants (piles, chats, vidéos, notifications) et la caméra du
 * jeu (ZoneScene.hudInsets) se calent dessus au lieu d'une hauteur supposée :
 * une barre qui passe sur deux lignes ou gagne un bouton les décale d'elle-même.
 * Valeurs par défaut (HUD absent) : `:root` de ds.css.
 */
export function usePublishHudInsets(): void {
  useEffect(() => {
    const root = document.documentElement;
    let last = '';
    const update = () => {
      const tops = [...document.querySelectorAll('[data-hud-top]')].map((el) => el.getBoundingClientRect().bottom);
      const bar = document.querySelector('[data-hud-bottom]');
      const tools = document.querySelector('[data-hud-top="right"]');
      const top = tops.length ? Math.round(Math.max(...tops)) : 0;
      const bottom = bar ? Math.round(window.innerHeight - bar.getBoundingClientRect().top) : 0;
      const toolsWidth = tools ? Math.round(tools.getBoundingClientRect().width) : 0;
      const key = `${top},${bottom},${toolsWidth}`;
      if (key === last) return;
      last = key;
      setPx(root, '--pl-hud-top', top);
      setPx(root, '--pl-hud-bottom', bottom);
      setPx(root, '--pl-hud-tools', toolsWidth);
      EventBus.emit('ui:hud-insets-changed', {});
    };
    update();
    const ro = new ResizeObserver(update);
    for (const el of document.querySelectorAll('[data-hud-top], [data-hud-bottom]')) ro.observe(el);
    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
      for (const name of ['--pl-hud-top', '--pl-hud-bottom', '--pl-hud-tools']) root.style.removeProperty(name);
      EventBus.emit('ui:hud-insets-changed', {});
    };
  }, []);
}

function setPx(root: HTMLElement, name: string, value: number): void {
  if (value > 0) root.style.setProperty(name, `${value}px`);
  else root.style.removeProperty(name);
}
